import { Word } from 'd3-cloud'

export const WORDCLOUD_MAX_WORDS = 120
export const WORDCLOUD_WIDTH = 600
export const WORDCLOUD_HEIGHT = 380

export const GRAPH_COLOURS = ['#D55E00', '#E69F00', '#56B4E9', '#009E73', '#0072B2', '#CC79A7', '#F0E442']
export const GRAPH_MARGIN = { top: 5, right: 20, left: 10, bottom: 5 }
export const GRAPH_TARGET_TICKS = 8

export type TickFormatter = (value: unknown) => string

export type CloudWord = Word & { colour?: string }

export type GraphDataRow = Record<string, string | number | null>
export type GraphSpan = { date: string, end: string, title: string }
export type GraphAxisGroup = { title: string, fields: string[] }
export type OutlierDay = { date: string, value: number, title?: string }
export type OutlierMarker = { x: string, days: OutlierDay[] }
export type GraphData = {
    graphType: 'line' | 'bar' | 'cloud'
    xAxis?: string
    yAxes?: string[]
    colour?: string
    title?: string
    yTitle?: string
    yAxisGroups?: GraphAxisGroup[]
    fieldNames?: Record<string, string>
    outliers?: Record<string, OutlierMarker[]>
    xLabelFormatter?: (value: string) => string
    xTickFormatter?: (value: string) => string
    data: GraphDataRow[]
    spans?: GraphSpan[]
}

export type GraphLegendItem = { value: string, label: string, color: string }
export type GraphLegendProps = {
    payload?: ReadonlyArray<GraphLegendItem>
    spans?: GraphSpan[]
    selectedKey: string | null
    selectedSpan: string | null
    onSeriesClick: (value: string) => (e: React.MouseEvent) => void
    onSeriesHover: (value: string | null) => void
    onSpanClick: (title: string) => (e: React.MouseEvent) => void
    onSpanHover: (title: string | null) => void
}

export type GraphSpanDelimitersProps = {
    spans: GraphSpan[]
    dates: string[]
    activeSpan: string | null
}

type TooltipPayloadItem = {
    name: string
    value: number
    color: string
    payload?: GraphDataRow
}

export type CustomTooltipProps = {
    active?: boolean
    payload?: TooltipPayloadItem[]
    label?: string
    extraFields: string[]
    xLabelFormatter?: (value: string) => string
}

export type GraphProps = { data: GraphData, onClick?: (e: React.MouseEvent<HTMLDivElement>) => void }
